import { SchoolYear } from '@schooly/api';
import { isWithinInterval, parseISO } from 'date-fns';
import { useCallback, useMemo } from 'react';

export const useDisableDayWithinSingleSchoolYear = ({
  fromDate,
  toDate,
  getSchoolYearForDate,
  enabled = false,
}: {
  fromDate: Date | null;
  toDate: Date | null;
  getSchoolYearForDate: (v: Date) => SchoolYear | undefined;
  enabled?: boolean;
}) => {
  const schoolYearIntervalOfFirstSelectedDate = useMemo(() => {
    if (!fromDate || (fromDate && toDate) || !enabled) return null;
    const schoolYear = getSchoolYearForDate(fromDate);

    if (!schoolYear) return null;

    return {
      start: parseISO(schoolYear.start),
      end: parseISO(schoolYear.end),
    };
  }, [getSchoolYearForDate, fromDate, toDate, enabled]);

  const shouldDisableDay = useCallback(
    (dateOfDay: Date) => {
      if (!enabled) return false;
      if (!schoolYearIntervalOfFirstSelectedDate) return false;
      return !isWithinInterval(dateOfDay, schoolYearIntervalOfFirstSelectedDate);
    },
    [schoolYearIntervalOfFirstSelectedDate, enabled],
  );

  return shouldDisableDay;
};
